'use client'

import { Facebook } from 'lucide-react'
import { trackEvent, trackVetCampaignConversion } from '@/lib/analytics'

// The ads are Facebook-driven and our page there carries more for clinics to
// explore, so the CTA sends them straight to it.
const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61578236016985'

interface Props {
  /** 'hero' = solid blue button on light bg; 'closing' = white button on blue bg. */
  variant?: 'hero' | 'closing'
  label?: string
}

/**
 * Primary CTA for the /for-vets campaign page. Links to our Facebook page and
 * records a campaign conversion on click.
 */
export default function ForVetsCTA({ variant = 'hero', label }: Props) {
  const text = label ?? 'Get in touch'

  const classes =
    variant === 'closing'
      ? 'bg-white text-[#004da9] hover:bg-[#f0f6fb] shadow-2xl shadow-black/20'
      : 'bg-[#004da9] text-white hover:bg-[#003d8a] shadow-lg shadow-[#004da9]/25'

  return (
    <a
      href={FACEBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        trackEvent('forvets_cta_clicked', { variant })
        trackVetCampaignConversion({ variant, action: 'facebook' })
      }}
      className={`inline-flex items-center gap-2.5 px-8 sm:px-6 py-4 sm:py-3.5 text-[18px] sm:text-[16px] rounded-full font-semibold transition-all duration-300 ${classes}`}
    >
      <Facebook className="w-5 h-5" />
      {text}
    </a>
  )
}
